import { channel } from "@tm/models"
import { PostMessageOptions } from "."

export function handleEreContinueToCalculation({ data }: PostMessageOptions) {
    if (data.ereContinueToCalculation) {
        channel("GLOBAL").publish("DMG_EUROTAX/EXTERNAL_TOOL_DONE", {})
    }
}
